export function preferredCustomerName(
  manualName: string | null | undefined,
  whatsappProfileName: string | null | undefined,
): string | null {
  return manualName?.trim() || whatsappProfileName?.trim() || null;
}
